import React from "react";

import { Typography } from "@/components/Typography";
import { Table } from "@/components/Table";
import { RichTextList } from "./RichTextList";

import { RichtextItem } from "@/types/types";

export const RichTextBlock = ({ item }: { item: RichtextItem }) => {
  return (
    <Typography
      classname={item.classname}
      spacing={item.spacing}
      size={item.size}
      Tag={item.tag}>
      {renderRichTextItem(item)}
      {item.subcontent && renderRichTextSubItem(item.subcontent)}
    </Typography>
  );
};

export const renderRichTextItem = (item: RichtextItem) => {
  if (item.table) return <Table data={item.table} />;
  if (item.list) return <RichTextList list={item.list} />;
  return <span dangerouslySetInnerHTML={{ __html: item.content }} />;
};

export const renderRichTextSubItem = (subitem: RichtextItem) => {
  return (
    <Typography
      classname={subitem.classname}
      spacing={subitem.spacing}
      size={subitem.size}
      Tag={subitem.tag}>
      <span dangerouslySetInnerHTML={{ __html: subitem.content }} />
    </Typography>
  );
};
